import { ApolloError, useMutation } from "@apollo/client";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import {
  UpdateExperienceMutation as UpdateExperienceMutationType,
  UpdateExperienceMutationVariables,
} from "./__generated__/UpdateExperienceMutation";

const UpdateExperienceMutation = loader("./UpdateExperienceMutation.gql");

type UpdateExperienceMutationProviderType = (props: {
  children: (loading: boolean, mutate: any) => ReactNode;
  onError: (error: ApolloError) => void;
  onCompleted: (data: UpdateExperienceMutationType) => void;
}) => ReactElement;

export const UpdateExperienceMutationProvider: UpdateExperienceMutationProviderType = (props) => {
  const { children, onError, onCompleted } = props;

  const [mutate, { loading }] = useMutation<UpdateExperienceMutationType, UpdateExperienceMutationVariables>(
    UpdateExperienceMutation,
    {
      errorPolicy: "none",
      onError,
      onCompleted,
    },
  );

  return <Fragment>{children(loading, mutate)}</Fragment>;
};
